import useViewportName from '@apps/www/src/www/hooks/useViewportName';

function _BreakpointName() {
	const viewportName = useViewportName();

	return <div className="text-xs">{viewportName}</div>;
}

export default function SVDevTools() {
	return (
		<div className="pointer-events-none fixed bottom-0 left-0 z-[1000] opacity-50">
			<div className="text-primary mb-2 ml-2 rounded bg-gray-900 px-3 py-2">
				<_BreakpointName />
			</div>
		</div>
	);
}
